import { useState, useRef, useEffect } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const tabCountStyle = {
    color: "white",
    borderRadius: "15px",
    minWidth: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 15px",
};

const TabsField = ({ tabsStyles, tabVal, handleTabsChange, tabData }) => {
    const theme = useTheme();
    const [hoverIndex, setHoverIndex] = useState(null);
    const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
    const tabsRef = useRef(null);

    useEffect(() => {
        const tabsNode = tabsRef.current;
        if (!tabsNode) return;

        const currentIndex = tabData.findIndex((item) => item.value === tabVal);
        const index = hoverIndex !== null ? hoverIndex : currentIndex;

        const tabEl = tabsNode.querySelectorAll(".MuiTab-root")[index];
        if (tabEl) {
            setIndicatorStyle({
                left: tabEl.offsetLeft,
                width: tabEl.offsetWidth,
            });
        } else {
            setIndicatorStyle({ left: 0, width: 0 });
        }
    }, [hoverIndex, tabVal, tabData]);

    return (
        <Tabs
            sx={tabsStyles}
            value={tabVal}
            onChange={handleTabsChange}
            ref={tabsRef}
            onMouseLeave={() => setHoverIndex(null)}
            TabIndicatorProps={{
                style: {
                    height: "5px",
                    borderRadius: "1em",
                    backgroundColor:
                        hoverIndex !== null && tabData[hoverIndex].value !== tabVal
                            ? theme.palette.primary.mainHover
                            : theme.palette.primary.main,
                    position: "absolute",
                    left: indicatorStyle.left,
                    width: indicatorStyle.width,
                    bottom: 0,
                    transition: "all 0.25s ease",
                },
            }}
        >
            {tabData.map((item, index) => (
                <Tab
                    key={item.value}
                    sx={{
                        textTransform: "none",
                        color:
                            item.value === tabVal
                                ? theme.palette.primary.main
                                : theme.palette.primary.greyFifth,
                        "&:hover": {
                            color:
                                item.value === tabVal
                                    ? theme.palette.primary.main
                                    : theme.palette.primary.mainHover,
                        },
                        '&.Mui-disabled': {
                            color: theme.palette.primary.greyThread,
                        },
                        ...(item.disabled && {
                            opacity: 0.5,
                            pointerEvents: "none",
                        }),
                    }}
                    label={item.name}
                    value={item.value}
                    disabled={item.disabled}
                    onMouseEnter={() => setHoverIndex(index)}
                    iconPosition={item.iconPosition || "end"}
                    icon={
                        item.tabCount ? (
                            <Box
                                sx={{
                                    ...tabCountStyle,
                                    backgroundColor:
                                        item.value === tabVal
                                            ? theme.palette.primary.main
                                            : hoverIndex === index
                                                ? theme.palette.primary.mainHover
                                                : theme.palette.primary.greyThird,
                                }}
                            >
                                {item.tabCount}
                            </Box>
                        ) : item.value === tabVal ? (
                            item.icon
                        ) : hoverIndex === index ? (
                            item.iconHover
                        ) : (
                            item.icon
                        )
                    }
                />
            ))}
        </Tabs>
    );
};

export default TabsField;
